import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Modulo from "model/administracao/cadastro/Modulo";
import Pessoa from "model/administracao/cadastro/Pessoa";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import Produto from "model/administracao/cadastro/produto/Produto";
import ProdutoFornecedor from "model/administracao/cadastro/produto/ProdutoFornecedor";
import PlanoInspecao from "model/qualidade/PlanoInspecao";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import ContaService from "service/administracao/cadastro/ContaService";
import ProdutoFornecedorService from "service/administracao/cadastro/produto/ProdutoFornecedorService";
import { pessoaCompleteMethod, pessoaItemTemplate, produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";

const produtoFornecedorService = new ProdutoFornecedorService();
const contaService = new ContaService();

export default function ProdutoFornecedorCadastro() {

    const { control, setFocus, clearErrors, setError, register, formState: { errors } } = useForm();

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const [queryParameters] = useSearchParams();
    const titulo = "Produto x Fornecedor";

    const [planosInspecao, setPlanosInspecao] = useState<PlanoInspecao[]>([]);
    const [planosInspecaoFiltrados, setPlanosInspecaoFiltrados] = useState<PlanoInspecao[]>([]);
    const [familias, setFamilias] = useState<FamiliaProduto[]>([]);
    const [fornecedores, setFornecedores] = useState<Pessoa[]>([]);
    const [fornecedoresFiltrados, setFornecedoresFiltrados] = useState<any[]>([]);
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<Produto[]>([]);


    const [modulosDisponiveis, setModulosDisponiveis] = useState<Modulo[]>([]);

    useEffect(() => {
        contaService.getModulosDisponiveis().then(lista => {
            setModulosDisponiveis(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoFornecedorService.familias().then(lista => {
            setFamilias(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoFornecedorService.fornecedores().then(lista => {
            setFornecedores(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoFornecedorService.planosInspecao().then(lista => {
            setPlanosInspecao(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoFornecedorService.produtos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err);
        });
    }, [])

    const [produtoFornecedor, setProdutoFornecedor] = useState<ProdutoFornecedor>(new ProdutoFornecedor());

    function validar() {

        if (!produtoFornecedor.produto || !produtoFornecedor.produto.codigo) {
            setError("produto", { type: "manual", message: "Produto é obrigatório" }, { shouldFocus: true })
            return false;
        }

        if (!produtoFornecedor.fornecedor || !produtoFornecedor.fornecedor?.nome) {
            setError("fornecedor", { type: "manual", message: "Fornecedor é obrigatório" }, { shouldFocus: true });
            msgAlerta("Informe o fornecedor", "Fornecedor é obrigatório");
            return false;
        }
        if (!produtoFornecedor.fornecedor?.codigoInterno) {
            setError("fornecedor", { type: "manual", message: "Fornecedor é obrigatório" }, { shouldFocus: true });
            msgAlerta("Informe o fornecedor", "Fornecedor inválido");
            return false;
        }

        return true;
    }

    function isEditando() {
        return !window.location.pathname.includes('/cadastrar')
    }

    return (

        <BaseCadastro model={produtoFornecedor} service={produtoFornecedorService} setModel={(value: ProdutoFornecedor) => setProdutoFornecedor(value)} validar={() => validar()} urlService="/produtoFornecedor" pathCadastro="/produtoFornecedor" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Produto</Label>
                <div className="col-sm-12">
                    <Controller name="produto" control={control} render={({ field }) => (
                        <AutoComplete
                            inputRef={field.ref}
                            dropdown
                            placeholder="Selecione o produto" disabled={isEditando()} value={produtoFornecedor.produto}
                            suggestions={produtosFiltrados} field="nome"
                            itemTemplate={(item: Produto) => produtoItemTemplate(item)}
                            completeMethod={(e) => {
                                let filtered = produtoCompleteMethod(produtos, e.query);
                                setProdutosFiltrados(filtered);
                            }}
                            onChange={(e) => {
                                clearErrors("produto")
                                if (typeof e.target.value == "string") {
                                    let prod = new Produto();
                                    prod.nome = e.target.value;
                                    produtoFornecedor.produto = prod;
                                } else {
                                    produtoFornecedor.produto = e.target.value;
                                }
                                setProdutoFornecedor({ ...produtoFornecedor })
                            }}
                            inputStyle={{ width: '100%' }}
                            style={{ width: '30%' }}
                        />
                    )} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Fornecedor</Label>
                <div className="col-sm-12">
                    <Controller name="fornecedor" control={control} render={({ field }) => (
                        <AutoComplete
                            inputRef={field.ref}
                            dropdown
                            value={produtoFornecedor.fornecedor}
                            placeholder="Selecione um Fornecedor"
                            style={{ width: '30%' }}
                            className={errors.fornecedor ? "p-invalid" : ""}
                            field="nome"
                            itemTemplate={(item: Pessoa) => pessoaItemTemplate(item)}
                            suggestions={fornecedoresFiltrados}
                            completeMethod={(e) => {
                                let filtered: Pessoa[] = pessoaCompleteMethod(fornecedores, e.query);
                                setFornecedoresFiltrados(filtered);
                            }}
                            onChange={(e) => {
                                clearErrors("fornecedor")
                                let produtoFornecedorLocal = JSON.parse(JSON.stringify(produtoFornecedor));

                                if (!e.target.value) {
                                    produtoFornecedorLocal.fornecedor = null;
                                } else if (typeof e.target.value == "string") {
                                    let fornecedor = new Pessoa();
                                    fornecedor.nome = e.target.value;
                                    produtoFornecedorLocal.fornecedor = fornecedor;
                                } else {
                                    produtoFornecedorLocal.fornecedor = e.target.value;
                                }
                                setProdutoFornecedor(produtoFornecedorLocal);
                            }}
                        />
                    )} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Código do produto no fornecedor</Label>
                <div className="col-sm-12">
                    <InputText required value={produtoFornecedor.codigoProdutoFornecedor} style={{ width: '100%' }}
                        maxLength={20}
                        className={errors.codigoProdutoFornecedor ? "p-invalid" : ""}
                        {...register("codigoProdutoFornecedor", {
                            onChange: (e) => {
                                clearErrors("codigoProdutoFornecedor");
                                setProdutoFornecedor({ ...produtoFornecedor, codigoProdutoFornecedor: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.codigoProdutoFornecedor && errors.codigoProdutoFornecedor.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigoProdutoFornecedor?.message as string}</span> : null}
            </div>

            {contaService.temModulo(modulosDisponiveis, "MDL_PRD") || contaService.temModulo(modulosDisponiveis, "MDL_QLD") ? <div className="row">
                <Label className="col col-sm-12">Plano de inspeção</Label>
                <div className="col-sm-12">
                    <Controller name="planoInspecao" control={control} render={({ field }) => (
                        <AutoComplete
                            inputRef={field.ref}
                            inputClassName={errors.planoInspecao ? "p-invalid" : ""}
                            dropdown
                            value={produtoFornecedor.planoInspecao}
                            placeholder="Selecione um Plano de Inspeção"
                            style={{ width: '30%' }}
                            inputStyle={{ width: '100%' }}
                            field="nome"
                            itemTemplate={(item: PlanoInspecao) => { return item.codigoInterno + " - " + item.nome }}
                            suggestions={planosInspecaoFiltrados}
                            completeMethod={(e) => {
                                let query = e.query;
                                let filtered: PlanoInspecao[] = [];
                                for (let i = 0; i < planosInspecao.length; i++) {
                                    let plano: PlanoInspecao = planosInspecao[i];
                                    if (plano.codigoInterno.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                                        filtered.push(plano);
                                    } else if (plano.nome.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                                        filtered.push(plano);
                                    } else if ((plano.codigoInterno + " - " + plano.nome).toLowerCase().indexOf(query.toLowerCase()) == 0) {
                                        filtered.push(plano);
                                    }
                                }
                                setPlanosInspecaoFiltrados(filtered);
                            }}
                            onChange={(e) => {
                                clearErrors("planoInspecao")
                                let produtoFornecedorLocal = JSON.parse(JSON.stringify(produtoFornecedor));
                                if (!e.target.value) {
                                    produtoFornecedorLocal.planoInspecao = null;
                                } else if (typeof e.target.value == "string") {
                                    let plano = new PlanoInspecao();
                                    plano.nome = e.target.value;
                                    produtoFornecedorLocal.planoInspecao = plano;
                                } else {
                                    produtoFornecedorLocal.planoInspecao = e.target.value;
                                }

                                setProdutoFornecedor(produtoFornecedorLocal);
                            }}

                        />
                    )} />
                </div>
                {errors.planoInspecao && errors.planoInspecao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.planoInspecao?.message as string}</span> : null}
            </div> : null}
        </BaseCadastro>
    )
}
